import React from "react";
import { Row, Col } from "react-flexbox-grid/lib/index";
import PropTypes from "prop-types";
import Tooltip from "@material-ui/core/Tooltip";
import TravelExploreSharpIcon from "@mui/icons-material/TravelExploreSharp";
import SelectSearchable from "components/Select";

import { toTitleCase } from "./DownloadCommon";
import getDropdownOptions from "../autocomplete";

const DownloadFilters = props => {
  const {
    chips,
    changeChip,
    displayColumns,
    columnNames,
    autoCompleteTree,
    filtersWithDropDowns,
    isFetchingAutoCompleteTree
  } = props;

  return (
    <Row>
      {props.displayFilter
        .filter(field => columnNames.includes(field))
        .map(field => {
          let isFetching = false;
          const label =
            displayColumns.has(field) &&
            displayColumns.get(field).display_column
              ? displayColumns.get(field).display_column
              : field
                  .split("_")
                  .map(toTitleCase)
                  .join(" ");

          // not all fields will be drop downs because their datasets too big
          let options = [];
          if (props.filtersWithDropDowns.includes(field)) {
            isFetching = isFetchingAutoCompleteTree;

            options = getDropdownOptions(
              autoCompleteTree,
              chips,
              field,
              filtersWithDropDowns
            );
          }

          return (
            <Col xs={12} md={6} key={field}>
              <div style={{ position: "relative" }}>
                <SelectSearchable
                  isMulti
                  label={label}
                  isLoading={isFetching}
                  placeholder={
                    <span>
                      Limit to {label}{" "}
                      {options.length ? `(${options.length} options)` : ""}
                    </span>
                  }
                  useCreatable={!options.length}
                  options={options}
                  value={chips[field]}
                  onChange={allChips => {
                    changeChip(field, allChips);
                  }}
                  extraIcon={
                    field === "site_id" ? (
                      <Tooltip
                        title={
                          <h1 style={{ fontSize: "1.5em" }}>Search on Map</h1>
                        }
                      >
                        <TravelExploreSharpIcon fontSize="large" />
                      </Tooltip>
                    ) : null
                  }
                  disabled={!props.recordCount || props.isFetchingRecordCount}
                  onExtraIconClick={() => props.handleOpenMapSearch(options)}
                />
              </div>
            </Col>
          );
        })}
    </Row>
  );
};

DownloadFilters.propTypes = {
  // eslint-disable-next-line
  displayColumns: PropTypes.object.isRequired,
  filtersWithDropDowns: PropTypes.arrayOf(PropTypes.string).isRequired,
  // eslint-disable-next-line
  dropDownOptions: PropTypes.object.isRequired,
  // eslint-disable-next-line
  autoCompleteTree: PropTypes.arrayOf(PropTypes.object).isRequired,
  // eslint-disable-next-line
  chipText: PropTypes.object.isRequired,
  // eslint-disable-next-line
  chips: PropTypes.object.isRequired,
  changeChip: PropTypes.func.isRequired,
  displayFilter: PropTypes.arrayOf(PropTypes.string).isRequired,
  columnNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  isFetchingAutoCompleteTree: PropTypes.bool.isRequired,
  recordCount: PropTypes.number.isRequired,
  isFetchingRecordCount: PropTypes.bool.isRequired,
  handleOpenMapSearch: PropTypes.func.isRequired
};
export default DownloadFilters;
